<div class="grid-container">
  <div class="grid-row grid-gap">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
      <legend class="usa-legend usa-legend--large">Negative Shipment Reporting</legend>
    </div>
  </div>
  <form id="negativeShipmentSubmissionGroup" role="form" [formGroup]="negativeShipmentSubmissionGroup">

    @if (reportSubmissionSuccess) {
      <div class="grid-row">
        <div class="usa-alert usa-alert--success maxw-full">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              GSA has received your Negative Shipment Report(s) for the below selected Reporting Year(s)/Quarter(s), selected Move Type(s) and Transportation Type(s).
            </p>
          </div>
        </div>
      </div>
    }

    @if (reportSubmissionFailure) {
      <div class="grid-row">
        <div class="usa-alert usa-alert--error usa-alert--no-icon">
          <div class="usa-alert__body">
            @if (reportStatus?.response === 'DUPLICATE') {
              <p class="usa-alert__text">
                A report already exists for the selected Reporting Year(s)/Quarter(s), Move Type(s), and Transportation Type(s). Negative Shipment report submission cannot proceed.
              </p>
            }
            @if (reportStatus?.response === 'Pending') {
              <p class="usa-alert__text">
                A pending report already exists for the selected Reporting Year(s)/Quarter(s), Move Type(s), and Transportation Type(s). Negative Shipment report submission cannot proceed.
              </p>
            }
          </div>
        </div>
      </div>
    }

    <div class="grid-row grid-gap padding-y-4">
      @if (showCarrierTSPs) {
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="carrierTSPSelect" class="usa-label">TSPs</label>
          <select id="carrierTSPSelect" class="usa-select maxw-full" formControlName='carrierTSPSelect' (change)="loadCarrierApprovalInfo($event.target.value)">
            <option hidden value='' selected disabled>Choose...</option>
            @for (carrierTspSingle of carrierTSPsList; track carrierTspSingle) {
              <option [value]="carrierTspSingle.value">
              {{carrierTspSingle.name}}</option>
            }
          </select>
        </div>
      }

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="reportingYrQuarterSelect" class="usa-label">Reporting Year/Quarter</label>
        <select id="reportingYrQuarterSelect" class="maxw-full usa-select" formControlName='reportingYrQuarterSelect'
          (change)="changeReportingQtrYear($event.target.value)">
          <option hidden value='' selected disabled>Choose...</option>
          @for (reportingYrQuarterSingle of reportingYrQuarterList; track reportingYrQuarterSingle) {
            <option
            [value]="reportingYrQuarterSingle.value">{{reportingYrQuarterSingle.name}}</option>
          }
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="moveTypeSelect" class="usa-label">Move Type</label>
        <select (change)="changeMoveType($event)" id="moveTypeSelect" class="maxw-full usa-select" formControlName='moveTypeSelect'>
          <option hidden value='' selected disabled>Choose...</option>
          @for (transTypeSingle of movingTypeList; track transTypeSingle) {
            <option [value]="transTypeSingle.value">
            {{transTypeSingle.name}}</option>
          }
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="transTypeSelect" class="usa-label">Transportation Type</label>
        <select id="transTypeSelect" class="usa-select maxw-full" formControlName='transTypeSelect'>
          <option hidden value='' selected disabled>Choose...</option>
          @for (transTypeSingle of transTypeList; track transTypeSingle) {
            <option [value]="transTypeSingle.value">
            {{transTypeSingle.name}}</option>
          }
        </select>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <button type="button" class="usa-button" [disabled]="!negativeShipmentSubmissionGroup.valid"
        (click)='submitReport(this.negativeShipmentSubmissionGroup.value)'>Submit</button>
      </div>
    </div>

  </form>
</div>